var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2416_2496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8208 42.875L40.4583 28.6125M28.5437 40.6104L42.8521 46.8708M71.4542 59.3896L57.1479 53.1271M53.1792 57.125L59.5417 71.3875M26.5625 50C26.5625 56.216 29.0318 62.1774 33.4272 66.5728C37.8226 70.9682 43.784 73.4375 50 73.4375C56.216 73.4375 62.1774 70.9682 66.5728 66.5728C70.9682 62.1774 73.4375 56.216 73.4375 50C73.4375 43.784 70.9682 37.8226 66.5728 33.4272C62.1774 29.0318 56.216 26.5625 50 26.5625C43.784 26.5625 37.8226 29.0318 33.4272 33.4272C29.0318 37.8226 26.5625 43.784 26.5625 50Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 50C42.1875 52.072 43.0106 54.0591 44.4757 55.5243C45.9409 56.9894 47.928 57.8125 50 57.8125C52.072 57.8125 54.0591 56.9894 55.5243 55.5243C56.9894 54.0591 57.8125 52.072 57.8125 50C57.8125 47.928 56.9894 45.9409 55.5243 44.4757C54.0591 43.0106 52.072 42.1875 50 42.1875C47.928 42.1875 45.9409 43.0106 44.4757 44.4757C43.0106 45.9409 42.1875 47.928 42.1875 50Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2416_2496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/cd.95c4633c66f0c93825b4dc9bac46bed5.svg";
export { ForwardRef as ReactComponent };